import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Inbox, Rocket, FileText, CheckCircle2, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/lib/seo";

function Stat({ icon: Icon, label, value, sub, to }) {
  return (
    <Link to={to} className="group rounded-2xl border border-navy-border bg-navy-surface p-6 transition-colors hover:border-astro-blue/40" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between">
        <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-astro-blue/10 text-astro-light"><Icon className="h-5 w-5" /></div>
        {sub != null && <span className="rounded-full bg-astro-blue/15 px-2.5 py-1 text-xs font-semibold text-astro-light">{sub} new</span>}
      </div>
      <p className="mt-5 font-heading text-4xl font-black text-white">{value ?? "—"}</p>
      <p className="mt-1 text-sm text-silver/60">{label}</p>
    </Link>
  );
}

export default function Dashboard() {
  const { data } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  return (
    <>
      <Seo title="Admin Dashboard" description="" path="/admin" />
      <h1 className="font-heading text-3xl font-black text-white">Dashboard</h1>
      <p className="mt-2 text-silver/60">Overview of submissions and content.</p>
      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <Stat icon={Inbox} label="Contact Enquiries" value={data?.contacts} sub={data?.contacts_new} to="/admin/contacts" />
        <Stat icon={Rocket} label="Private Beta Requests" value={data?.beta} sub={data?.beta_new} to="/admin/beta" />
        <Stat icon={FileText} label="Blog Articles" value={data?.posts} sub={data?.posts_published} to="/admin/blog" />
        <Stat icon={Mail} label="Newsletter Subscribers" value={data?.newsletter} to="/admin" />
      </div>
      <div className="mt-8 rounded-2xl border border-navy-border bg-navy-surface p-8">
        <div className="flex items-center gap-3">
          <CheckCircle2 className="h-6 w-6 text-astro-light" />
          <h2 className="font-heading text-lg font-semibold text-white">System status</h2>
        </div>
        <p className="mt-3 text-sm text-silver/60">All submissions are stored with a full status workflow (New → Reviewing → Approved / Rejected → Contacted) and a complete audit trail. Team notifications are dispatched by email on each new submission.</p>
      </div>
    </>
  );
}
